import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    // @ts-expect-error Props exist
    right: ({ useModalWidth }) =>
      useModalWidth ? `calc(${useModalWidth}px + 10px)` : '1rem',
    bottom: '1rem',
    display: 'flex',
    alignItems: 'center'
  }
}))

export default useStyles
